module.exports = __webpack_public_path__ + "static/media/logo-supplied.59556ea9.png";